<template>
  <!--

  The v-menu is attached to a mounting point so that it renders in the right 
  position when the video and controls are displayed fullscreen.

  -->
  <div ref="mount_point">
    <v-menu
      ref         = "menu"
      top
      left
      offset-y
      :close-on-content-click = "false"
      :attach     = "$refs.mount_point"
      max-width   = "350"
      min-width   = "350"
      max-height  = "350"
      @input      = "onMenuToggled"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          icon 
          v-bind    = "attrs" 
          v-on      = "on" 
          :disabled = "!video.canPlay"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>

      <v-list dense
              v-if="!submenu"
      >
        <v-list-item 
          :disabled = "!hasAudio"
          @click    = "showMenu('audio_tracks')"
        >
          <v-list-item-content>
            <v-list-item-title>Audio Tracks</v-list-item-title>
            <v-list-item-subtitle>{{ audioTrackLabel }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item 
          :disabled = "!hasAudio"
          @click    = "showMenu('audio_channels')"
        >
          <v-list-item-content>
            <v-list-item-title>Audio Channels</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item @click="showMenu('video_quality')">
          <v-list-item-content>
            <v-list-item-title>Quality</v-list-item-title>
            <v-list-item-subtitle>{{ videoQuality }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item @click="showMenu('overlays')">
          <v-list-item-content>
            <v-list-item-title>Overlays</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>

        <v-list-item @click="showMenu('rotation')">
          <v-list-item-content>
            <v-list-item-title>Rotation</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon><v-icon>mdi-chevron-right</v-icon></v-list-item-icon>
        </v-list-item>

      </v-list>

      <AudioTracksMenu 
        v-if      = "submenu === 'audio_tracks'" 
        @back     = "showMenu(undefined)"
      >
      </AudioTracksMenu>

      <AudioChannelsMenu 
        v-if      = "submenu === 'audio_channels'"
        @back     = "showMenu(undefined)"
      >
      </AudioChannelsMenu>

      <VideoQualityMenu 
        v-if      = "submenu === 'video_quality'" 
        @back     = "showMenu(undefined)"
      >
      </VideoQualityMenu>

      <OverlaysMenu 
        v-if      = "submenu === 'overlays'" 
        @back     = "showMenu(undefined)"
      >
      </OverlaysMenu>

      <RotationMenu 
        v-if      = "submenu === 'rotation'" 
        @back     = "showMenu(undefined)"
      >
      </RotationMenu>
      
    </v-menu>
  </div>
</template>

<script lang="js">

// #region Imports

/* vuex */
import {mapState} from 'vuex';

/* Telestream */
import AudioChannelsMenu from './settings-menus/AudioChannelsMenu';
import AudioTracksMenu from './settings-menus/AudioTracksMenu';
import OverlaysMenu from './settings-menus/OverlaysMenu';
import VideoQualityMenu from './settings-menus/VideoQualityMenu';
import RotationMenu from './settings-menus/RotationMenu';

// #endregion Imports

export default {

  // #region Properties

  name: 'VideoSettings',
  data() {
    return {
      isOpen:  false,
      submenu: ''
    }
  },
  computed: {
    ...mapState([
      'video',
      'videoController'
    ]),
    hasAudio() {
      return this.videoController && this.videoController.currentAudioTrack;
    },
    audioTrack() {
      return this.videoController.currentAudioTrack?.track;
    },
    audioTrackLabel() {
      if (!this.hasAudio) {
        return 'Media does not contain audio.';
      } else {

        if (this.videoController.currentAudioTrack?.description)
        {
          return this.videoController.currentAudioTrack?.description;
        }

        return `Track ${this.audioTrack + 1}`;
      }
    },
    videoQuality() {
      if (!this.videoController) {
        return undefined;
      }

      const level = this.videoController.hls.levels[this.videoController.currentLevel];
      if (!level) {
        return undefined;
      }

      return level.name.replace(' Alpha channel', '');
    }
  },
  components: {
    AudioChannelsMenu,
    AudioTracksMenu,
    OverlaysMenu,
    VideoQualityMenu,
    RotationMenu
  },

  // #endregion Properties

  // #region Events

  methods: {
    showMenu(menu) {
      this.submenu = menu;
      this.$refs.menu.onResize();
    },
    onMenuToggled(isOpen) {
      this.isOpen = isOpen;

      // Reset on open (on close causes animation glitch).
      if (this.isOpen) {
        this.submenu = undefined;
      }
    },
    onMenuResized() {
      this.$refs.menu.onResize();
    }
  }

  // #endregion Events

}
</script>
